module.exports = __webpack_public_path__ + "static/Ankit-Muchhala-618d4da3040f24747ab0e99e703a48fd.jpg";